import { Action } from '@ngrx/store';
import { GematikProcess } from '../../models/gematik-process.model';
import { GematikProcessTotals } from '../../models/gematik-process-totals.model';
import { GematikProcessCachedDto } from 'gematik-task-api';

// Load All Active Processes
export const LOAD_ALL_ACTIVE_PROCESSES = '[Processes] Load All Active Processes';
export const LOAD_ALL_ACTIVE_PROCESSES_SUCCESS = '[Processes] Load All Active Processes Success';
export const LOAD_ALL_ACTIVE_PROCESSES_FAIL = '[Processes] Load All Active Processes Fail';

export class LoadAllActiveProcesses implements Action {
  readonly type = LOAD_ALL_ACTIVE_PROCESSES;
}

export class LoadAllActiveProcessesSuccess implements Action {
  readonly type = LOAD_ALL_ACTIVE_PROCESSES_SUCCESS;
  constructor(public payload: { myProcesses: GematikProcess[]; subscriberProcesses: GematikProcess[] }) {}
}

export class LoadAllActiveProcessesFail implements Action {
  readonly type = LOAD_ALL_ACTIVE_PROCESSES_FAIL;
  constructor(public payload: any) {}
}

// Load Active Processes
export const LOAD_ACTIVE_PROCESSES = '[Processes] Load Active Processes';
export const LOAD_ACTIVE_PROCESSES_SUCCESS = '[Processes] Load Active Processes Success';
export const LOAD_ACTIVE_PROCESSES_FAIL = '[Processes] Load Active Processes Fail';

export class LoadActiveProcesses implements Action {
  readonly type = LOAD_ACTIVE_PROCESSES;
  constructor(public payload: string) {}
}

export class LoadActiveProcessesSuccess implements Action {
  readonly type = LOAD_ACTIVE_PROCESSES_SUCCESS;
  constructor(
    public payload: { myProcesses: GematikProcess[]; subscriberProcesses: GematikProcess[] },
    public backendUrl: string,
  ) {}
}

export class LoadActiveProcessesFail implements Action {
  readonly type = LOAD_ACTIVE_PROCESSES_FAIL;
  constructor(public payload: any) {}
}

// Load My Completed Processes
export const LOAD_MY_COMPLETED_PROCESSES = '[Processes] Load My Completed Processes';
export const LOAD_MY_COMPLETED_PROCESSES_SUCCESS = '[Processes] Load My Completed Processes Success';
export const LOAD_MY_COMPLETED_PROCESSES_FAIL = '[Processes] Load My Completed Processes Fail';

export class LoadMyCompletedProcesses implements Action {
  readonly type = LOAD_MY_COMPLETED_PROCESSES;
}

export class LoadMyCompletedProcessesSuccess implements Action {
  readonly type = LOAD_MY_COMPLETED_PROCESSES_SUCCESS;
  constructor(public payload: { myProcesses: GematikProcess[]; subscriberProcesses: GematikProcess[] }) {}
}

export class LoadMyCompletedProcessesFail implements Action {
  readonly type = LOAD_MY_COMPLETED_PROCESSES_FAIL;
  constructor(public payload: any) {}
}

// Load Subscriber Completed Processes
export const LOAD_SUBSCRIBER_COMPLETED_PROCESSES = '[Processes] Load Subscriber Completed Processes';
export const LOAD_SUBSCRIBER_COMPLETED_PROCESSES_SUCCESS = '[Processes] Load Subscriber Completed Processes Success';
export const LOAD_SUBSCRIBER_COMPLETED_PROCESSES_FAIL = '[Processes] Load Subscriber Completed Processes Fail';

export class LoadSubscriberCompletedProcesses implements Action {
  readonly type = LOAD_SUBSCRIBER_COMPLETED_PROCESSES;
}

export class LoadSubscriberCompletedProcessesSuccess implements Action {
  readonly type = LOAD_SUBSCRIBER_COMPLETED_PROCESSES_SUCCESS;
  constructor(public payload: { myProcesses: GematikProcess[]; subscriberProcesses: GematikProcess[] }) {}
}

export class LoadSubscriberCompletedProcessesFail implements Action {
  readonly type = LOAD_SUBSCRIBER_COMPLETED_PROCESSES_FAIL;
  constructor(public payload: any) {}
}

// Totals
export const LOAD_PROCESS_TOTALS = '[Processes] Load Process Totals';
export const LOAD_PROCESS_TOTALS_SUCCESS = '[Processes] Load Process Totals Success';
export const LOAD_PROCESS_TOTALS_FAIL = '[Processes] Load Process Totals Fail';

export class LoadProcessTotals implements Action {
  readonly type = LOAD_PROCESS_TOTALS;
}

export class LoadProcessTotalsSuccess implements Action {
  readonly type = LOAD_PROCESS_TOTALS_SUCCESS;
  constructor(public payload: GematikProcessTotals) {}
}

export class LoadProcessTotalsFail implements Action {
  readonly type = LOAD_PROCESS_TOTALS_FAIL;
  constructor(public payload: any) {}
}

// Load active process
export const LOAD_ACTIVE_PROCESS = '[Processes] Load Active Process';
export const LOAD_ACTIVE_PROCESS_SUCCESS = '[Processes] Load Active Process Success';
export const LOAD_ACTIVE_PROCESS_FAIL = '[Processes] Load Active Process Fail';

export class LoadActiveProcess implements Action {
  readonly type = LOAD_ACTIVE_PROCESS;
  constructor(
    public payload: {
      backendUrl: string;
      instanceId: string;
      skipTotals?: boolean;
    },
  ) {}
}

export class LoadActiveProcessSuccess implements Action {
  readonly type = LOAD_ACTIVE_PROCESS_SUCCESS;
  constructor(
    public payload: GematikProcessCachedDto,
    public backendUrl: string,
    public skipTotals?: boolean,
  ) {}
}

export class LoadActiveProcessFail implements Action {
  readonly type = LOAD_ACTIVE_PROCESS_FAIL;
  constructor(public payload: any) {}
}

// Adjust Process Totals (supports signed deltas for open and completed)
export const ADJUST_PROCESS_TOTALS = '[Processes] Adjust Process Totals';

export class AdjustProcessTotals implements Action {
  readonly type = ADJUST_PROCESS_TOTALS;
  constructor(public payload: { openMy: number; openGroup: number; completedMy: number; completedGroup: number }) {}
}

// Process ended
export const PROCESS_ENDED = '[Processes] Process Ended';

export class ProcessEnded implements Action {
  readonly type = PROCESS_ENDED;
  constructor(public instanceId: string) {}
}

export type ProcessActions =
  | LoadAllActiveProcesses
  | LoadAllActiveProcessesSuccess
  | LoadAllActiveProcessesFail
  | LoadActiveProcesses
  | LoadActiveProcessesSuccess
  | LoadActiveProcessesFail
  | LoadMyCompletedProcesses
  | LoadMyCompletedProcessesSuccess
  | LoadMyCompletedProcessesFail
  | LoadSubscriberCompletedProcesses
  | LoadSubscriberCompletedProcessesSuccess
  | LoadSubscriberCompletedProcessesFail
  | LoadProcessTotals
  | LoadProcessTotalsSuccess
  | LoadProcessTotalsFail
  | ProcessEnded
  | LoadActiveProcess
  | LoadActiveProcessSuccess
  | LoadActiveProcessFail
  | AdjustProcessTotals;
